import React from 'react';
import './Spinner.scss'; // Import or define your styling

const Spinner = () => {
  return (
    <div className="spinner-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;